// extracted by mini-css-extract-plugin
module.exports = {"notifyButton":"_2mz02p"};